import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import checkIcon from "../../../img/icons/check-mark-approve-white.svg";

const Label = styled.label`
    cursor: ${props => (props.isDisabled ? "not-allowed" : "pointer")};
`;

const Input = styled.input`
    position: absolute;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px 1px 1px 1px);
    clip: rect(1px, 1px, 1px, 1px);
    + span {
        display: inline-block;
        color: ${props => (props.isDisabled ? "#999" : "#000")};
        font-size: 0.75rem;
        line-height: 1.063rem;
        user-select: none;
        &:before {
            content: "";
            display: inline-block;
            margin-right: 0.75rem;
            width: 1rem;
            height: 1rem;
            position: relative;
            top: 3px;
            border: ${props =>
                props.isChecked ? "1px solid transparent" : "1px solid gray"};
            border-radius: 3px;
            ${props =>
                props.isChecked
                    ? `background-image: url(${checkIcon});
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: cover;
                    background-color: #3ea9f5;`
                    : "background-color: #fff;"};
        }
    }

    &:focus + span:before {
        outline: 5px auto -webkit-focus-ring-color;
    }
`;

const Checkbox = ({ label, onClick, initialValue, isDisabled }) => {
    const [isChecked, toggleCheck] = useState(initialValue);

    return (
        <Label isDisabled={isDisabled}>
            <Input
                isDisabled={isDisabled}
                isChecked={isChecked}
                type="checkbox"
                value={label}
                defaultChecked={isChecked}
                aria-disabled={isDisabled}
                onClick={() => {
                    if (isDisabled) return;
                    toggleCheck(!isChecked);
                    onClick(!isChecked);
                }}
            />
            <span>{label}</span>
        </Label>
    );
};

Checkbox.propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    initialValue: PropTypes.bool.isRequired,
    isDisabled: PropTypes.bool.isRequired
};

export { Checkbox };
